export default "images/taking-picture.png";